var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 26,
    viewBox: "0 0 14 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92789 14.6639H0.759891C0.247891 14.6639 0.0878906 14.4719 0.0878906 13.9919V10.1199C0.0878906 9.60793 0.279891 9.44793 0.759891 9.44793H3.92789V6.63193C3.92789 5.35193 4.15189 4.13593 4.79189 3.01593C5.46389 1.86393 6.42389 1.09593 7.63989 0.647933C8.43989 0.359933 9.23989 0.231934 10.1039 0.231934H13.2399C13.6879 0.231934 13.8799 0.423934 13.8799 0.871934V4.51993C13.8799 4.96793 13.6879 5.15993 13.2399 5.15993C12.3759 5.15993 11.5119 5.15993 10.6479 5.19193C9.78389 5.19193 9.33589 5.60793 9.33589 6.50393C9.30389 7.46393 9.33589 8.39193 9.33589 9.38393H13.0479C13.5599 9.38393 13.7519 9.57593 13.7519 10.0879V13.9599C13.7519 14.4719 13.5919 14.6319 13.0479 14.6319H9.33589V25.0639C9.33589 25.6079 9.17589 25.7999 8.59989 25.7999H4.59989C4.11989 25.7999 3.92789 25.6079 3.92789 25.1279V14.6639Z",
    fill: "#4267B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.429263dce3c5c6d171484125b9bfa646.svg";
export { ForwardRef as ReactComponent };